import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row
} from "reactstrap";
import KycModal from "./KycModal"

const ReservationModals = ({
  modal,
  setModal,
  deleteModal,
  setDeleteModal,
  extensionModal,
  setExtensionModal,
  kycModal,
  setKycModal,
  formData,
  setFormData,
  roomTypes,
  roomsList,
  availableRooms,
  selectedRequest,
  setSelectedRequest,
  kycData,
  isEditMode,
  handleSaveBooking,
  handleDelete,
  handleApproveExtension,
  computeNights,
  computeExtendedNights,
  selectedBooking,
  onKycUploaded,
}) => {
  return (
    <>
      {/* Create/Edit Modal */}
      <Modal
        isOpen={modal}
        toggle={() =>
          setModal(!modal)
        }
        size="lg"
      >
        {/* Move your complete modal code here */}
      </Modal>

      {/* Delete Modal */}
      <Modal
        isOpen={deleteModal}
        toggle={() =>
          setDeleteModal(
            !deleteModal
          )
        }
      >
        {/* Delete Modal Code */}
      </Modal>

      {/* Extension Modal */}
      <Modal
        isOpen={
          extensionModal
        }
        toggle={() =>
          setExtensionModal(
            !extensionModal
          )
        }
      >
        {/* Extension Modal Code */}
      </Modal>

      {/* KYC Modal */}
      <KycModal
  isOpen={kycModal}
  toggle={() => setKycModal(false)}
  bookingId={selectedBooking?._id}
  onSuccess={onKycUploaded}
/>
    </>
  );
};

export default ReservationModals;